import * as React from "react";

import { redirectPlayerIfSignUpNotFinished, useSocialCoachSession } from "@/utils";

import { Statistics } from "./components/Statistics";
import { QuickActions } from "./components/QuickActions";
import { NeedsAttention } from "./components/NeedsAttention";
import { ReadyToPost } from "./components/ReadyToPost";

import { PageWrapper } from "@/components/PageWrapper";

export const PlayerDashboard: React.FC = () => {
  const { playerId, coachId, session } = useSocialCoachSession();

  React.useEffect(() => {
    redirectPlayerIfSignUpNotFinished(session);
  }, [session]);

  return (
    <PageWrapper>
      <div className={"flex flex-col gap-8"}>
        {playerId && (
          <>
            <Statistics playerId={playerId} coachId={coachId!} />
            <QuickActions playerId={playerId} />
            <NeedsAttention playerId={playerId} />
            <ReadyToPost playerId={playerId} />
          </>
        )}
      </div>
    </PageWrapper>
  );
};
